import { ReservationBasicInfo } from "./reservation-basic-info";

export class CategoryAvailableReservations
{
    public categoryId: number;
    public availableReservations: ReservationBasicInfo[];
}